module.exports = __webpack_public_path__ + "media/day/311-5a2c32e3.svg";